<template>
  <form class="mt-4" @submit.prevent="submitCategoryForm" @keyup.enter="submitCategoryForm">
    <Checkbox
      v-for="category in categories"
      :key="category.name"
      v-model="selectedCategories"
      :labelName="category.name"
      :value="category.name"
    />
    <button class="clear-btn bg-opacity-0 underline font-normal" @click.prevent="() => (selectedCategories = [])">
      Clear selection
    </button>
    <div class="w-full mt-24">
      <Button value="Save" type="submit" size="medium" class="w-full" />
    </div>
  </form>
</template>

<script lang="ts">
import Checkbox from '../checkbox/Checkbox.vue';
import Button from '../button/Button.vue';

export default {
  name: 'CategoryPopup',
  components: { Checkbox, Button },
  props: {
    allCategories: {
      type: [Object],
      default: () => {},
    },
    filterCategories: {
      type: Array<any>,
      default: [],
    },
    closeModal: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      selectedCategories: this.filterCategories,
    };
  },
  computed: {
    categories(): any {
      return this.allCategories?.categories;
    },
  },
  methods: {
    submitCategoryForm() {
      this.closeModal();

      const { query } = this.$route;
      this.$router.push({ query: { ...query, adventureCategoryName: JSON.stringify(this.selectedCategories) } });
    },
  },
};
</script>

<style lang="scss" scoped>
.clear-btn {
  color: #4b4c52;
}
</style>
